export const inputNumbersWithDecimalsRegExp = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/g;
